import * as React from 'react'
import {useBoldInputStyle} from 'components/common/useBoldInputStyle'
import {useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

export default function BusinessNumberInput() {
  const classes = useBoldInputStyle()
  const {t} = useTranslation()

  const {
    formState: {errors},
    register,
  } = useFormContext()

  return (
    <div className={classes.root}>
      <div className={classes.labelWrapContainer}>
        <p className={classes.inputLabel}>{t('IBusinessNo')}</p>
      </div>
      <input
        placeholder={t('IRegisterBusinessNo')}
        className={classes.input}
        {...register('businessNo')}
      />
      {errors.businessNo && (
        <span className={classes.errorText}>{errors.businessNo.message}</span>
      )}
    </div>
  )
}
